// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import '@fontsource/orbitron'
// import reportWebVitals from './reportWebVitals';
// import {
//   HashRouter as Router,
// } from "react-router-dom";

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   // <React.StrictMode>
//   <Router>
//     <App />
//   </Router>
//   // </React.StrictMode>
// );


// reportWebVitals();



import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@fontsource/orbitron';
import reportWebVitals from './reportWebVitals';
import { HashRouter as Router } from "react-router-dom";

// // ✅ ADD THESE:
// import { Provider } from 'react-redux';
// import store from './Store.js'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <Provider store={store}>
    <Router>
      <App />
    </Router>
  // </Provider>
);

reportWebVitals();
